import app from '@/app';
import templateUrl from './metric-limit-detail.html';

/* @ngInject */
function Controller($controller, $state, $translate, MetricLimit, Principal, AlertService) {
	var $ctrl = this;

	// The unifilar IFI column is the mean of IFI-F60 (see KpiBuilder), so the measurement
	// metric ifiF60 is graded by the same rule as the KPI metric ifi. The remaining IFI
	// metrics (macrotexture, microtexture, FR60, IFI-Sp) keep both limits.
	const SINGLE_LIMIT_METRIC_NAMES = ['vrd', 'gn', 'ifi', 'ifiF60'];

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: MetricLimit,
		type: 'metricLimit'
	});
	$ctrl.save = function() {
		if (!$ctrl.readonly) {
			$ctrl.isSaving = true;
			var onSuccess = function() {
				AlertService.success('entity.save.message', {
					type: $ctrl.type,
					name: $translate.instant($ctrl.parent.getMetricKey($ctrl.entity.metric))
				});
				$ctrl.isSaving = false;
				$state.go('^', {}, { reload: true });
			};
			var onError = function() {
				$ctrl.isSaving = false;
			};
			if ($ctrl.entity.id) {
				MetricLimit.update($ctrl.entity, onSuccess, onError);
			} else {
				MetricLimit.create($ctrl.entity, onSuccess, onError);
			}
		}
	};


	$ctrl.$onInit = function() {
		if ($ctrl.entity.metric) {
			$ctrl.measurement = _.find({ code: $ctrl.entity.metric })(
				$ctrl.parent.allMetrics
			).measurement;
		}
	};

	$ctrl.filterByMeasurement = function(value) {
		return $ctrl.measurement && $ctrl.measurement == value.measurement;
	};

	$ctrl.getMaxLimit = metric => {
		metric = $ctrl.parent.allMetrics.filter(m => m.code == metric)[0];
		return metric && metric.unit == 'PERCENT';
	};

	// VRD, GN and IFI are graded against a single configured threshold, the good limit:
	// at or above it the criterion is met, below it it is not. Their bad limit is never
	// read, so it is shown disabled instead of being asked for.
	$ctrl.isSingleLimit = metric => {
		metric = $ctrl.parent.allMetrics.filter(m => m.code == metric)[0];
		return !!metric && SINGLE_LIMIT_METRIC_NAMES.indexOf(metric.name) !== -1;
	};

	// Define the preventEnterSubmit function
	$ctrl.preventEnterSubmit = function(event) {
		if (event.keyCode === 13) {
			// Check if the key pressed is the Enter key (keyCode 13)
			event.preventDefault(); // Prevents the form submission
		}
	};
}

const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^metricLimitSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<'
	}
};

app.component('metricLimitDetail', component);
